import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["primaryButton", "secondaryButton"]

  markChanged () {
    this.primaryButtonTargets.forEach((button) => {
      button.classList.remove("btnv2--light")
      button.classList.add("btnv2--warning")
    })

    this.secondaryButtonTargets.forEach((button) => {
      button.classList.remove("btnv2--light")
      button.classList.add("btnv2--warning")
    })
  }
}
